import { Switch } from '@/components/ui/switch'
import { useExpertMode, useUserExpertModeAcknowledgement } from '@pancakeswap/utils/user/expertMode'
import { useState } from 'react'
import { useSwapActionHandlers } from '@/state/swap/useSwapActionHandlers'
import { ExpertModal } from '@pancakeswap/widgets-internal'

export const ExpertModeSwitcher = () => {
  const [showConfirmExpertModal, setShowConfirmExpertModal] = useState(false)
  const [showExpertModeAcknowledgement, setShowExpertModeAcknowledgement] = useUserExpertModeAcknowledgement()
  const { onChangeRecipient } = useSwapActionHandlers()
  const handleExpertModeToggle = () => {
    if (expertMode || !showExpertModeAcknowledgement) {
      onChangeRecipient(null)
      setExpertMode((s) => !s)
    } else {
      setShowConfirmExpertModal(true)
    }
  }

  const [expertMode, setExpertMode] = useExpertMode()

  return (
    <>
      {showConfirmExpertModal && (
        <ExpertModal
          setShowConfirmExpertModal={setShowConfirmExpertModal}
          toggleExpertMode={() => setExpertMode((s) => !s)}
          setShowExpertModeAcknowledgement={setShowExpertModeAcknowledgement}
        />
      )}
      <Switch checked={expertMode} onCheckedChange={handleExpertModeToggle} />
    </>
  )
}
